/** Historial de estados compartido por requerimientos y presupuestos. */
import { useQuery } from '@tanstack/react-query';
import { tenantIdOrNull, tenantScoped } from '@/config/queryClient';
import { commercialService, type EntityStatusHistoryDto } from '@/services/commercialService';
import { useMobileAuth } from '@/state/MobileAuthContext';

export type HistoryEntityType = 'customer_requirement' | 'budget';

export function useEntityStatusHistoryQuery(
  entityType: HistoryEntityType,
  entityId: string | null,
  enabled = true,
) {
  const { user } = useMobileAuth();
  const tenantId = tenantIdOrNull(user?.active_tenant_id);
  return useQuery<EntityStatusHistoryDto[]>({
    queryKey:
      tenantId !== null
        ? tenantScoped(tenantId, 'entity-status-history', entityType, entityId)
        : ['tenant', 'no-context', 'entity-status-history', entityType, entityId],
    queryFn: () => commercialService.entityStatusHistory(entityType, entityId!),
    enabled: tenantId !== null && entityId !== null && entityId !== '' && enabled,
    staleTime: 30_000,
  });
}
